<template><span style="display:none" aria-hidden="true"></span></template>

<script>
import { reportSecurityEvent } from '../services/security-log.service'

const COPY_SENTINEL = '.secret-text, .bank-chk, .owner-actions'

export default {
  name: 'SecurityDetector',
  data: function () {
    return { blurAt: 0, hiddenAt: 0 }
  },
  mounted: function () {
    const self = this

    this._onBlur = function () { self.blurAt = Date.now() }
    this._onFocus = function () {
      if (self.blurAt) {
        const d = Date.now() - self.blurAt
        if (d < 5000) reportSecurityEvent('POTENTIAL_SCREENSHOT', { blurDurationMs: d })
      }
      self.blurAt = 0
    }
    this._onVis = function () {
      if (document.hidden) {
        self.hiddenAt = Date.now()
      } else if (self.hiddenAt) {
        const d = Date.now() - self.hiddenAt
        if (d < 5000) reportSecurityEvent('TAB_HIDDEN', { hiddenDurationMs: d })
        self.hiddenAt = 0
      }
    }
    this._onPrint = function () { reportSecurityEvent('BEFORE_PRINT') }
    this._onCopy = function (e) {
      const target = e && e.target
      const hit = target && target.closest ? target.closest(COPY_SENTINEL) : null
      if (!hit) return
      let txt = ''
      try {
        txt = (e.clipboardData && e.clipboardData.getData ? e.clipboardData.getData('text') : '') ||
          (window.getSelection ? window.getSelection().toString() : '')
      } catch (_) { /* ignore */ }
      txt = (txt || '').slice(0, 64)
      const masked = txt.length > 4 ? (txt.slice(0, 4) + '*'.repeat(txt.length - 4)) : '*'.repeat(txt.length)
      reportSecurityEvent('COPY_SENSITIVE', { selectedText: masked })
    }

    window.addEventListener('blur', this._onBlur)
    window.addEventListener('focus', this._onFocus)
    document.addEventListener('visibilitychange', this._onVis)
    window.addEventListener('beforeprint', this._onPrint)
    document.addEventListener('copy', this._onCopy)
  },
  beforeDestroy: function () {
    window.removeEventListener('blur', this._onBlur)
    window.removeEventListener('focus', this._onFocus)
    document.removeEventListener('visibilitychange', this._onVis)
    window.removeEventListener('beforeprint', this._onPrint)
    document.removeEventListener('copy', this._onCopy)
  },
}
</script>
